import React, { useEffect, Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useDispatch } from "react-redux";

import { setLocalUser } from "../../../components/user/actions";
import DatacodeConfig from "../../../core/config";
import CustomLoader from "../../../shared_components/CustomLoader";
import EventsCollaborateLandingPage from "../../../components/main_component/events/components/EventsCollaborateLandingPage/EventsCollaborateLandingPage";
import RevisionLandingPage from "../../../components/main_component/events/components/RevisionLandingPage";



// --------------------------------------------
// import HomeComponent from "../../../components/main_component/home";
// Articles
const IndexArticles = lazy(() => import("../../../components/main_component/aticles/IndexArticles"));
// Progrmminng blogs
const ProgrammingLanguagesBlog = lazy(() => import("../../../components/main_component/aticles/programming_article/Programming_Languages_Blog"));
const ProgrammingBlog2 = lazy(() => import("../../../components/main_component/aticles/programming_article/ProgrammingBlog2"));
const ProgrammingBlog3 = lazy(() => import("../../../components/main_component/aticles/programming_article/ProgrammingBlog3"));
const ProgrammingBlog4 = lazy(() => import("../../../components/main_component/aticles/programming_article/ProgrammingBlog4"));
const ProgrammingBlog5 = lazy(() => import("../../../components/main_component/aticles/programming_article/ProgrammingBlog5"));
const ProgrammingBlog6 = lazy(() => import("../../../components/main_component/aticles/programming_article/ProgrammingBlog6"));
const ProgrammingBlog7 = lazy(() => import("../../../components/main_component/aticles/programming_article/ProgrammingBlog7"));
const ProgrammingBlog8 = lazy(() => import("../../../components/main_component/aticles/programming_article/ProgrammingBlog8"));
const ProgrammingBlog9 = lazy(() => import("../../../components/main_component/aticles/programming_article/ProgrammingBlog9"));

// Machine learning Blogs
const MachineLearningBlog = lazy(() => import("../../../components/main_component/aticles/machine_learning_article/MachineLearningBlog"));
//WebDesign Blog Pagination
const WebDesignBlog = lazy(() => import("../../../components/main_component/aticles/webdesign_article/WebDesignBlog"));
const WebDesignBlog2 = lazy(() => import("../../../components/main_component/aticles/webdesign_article/WebDesignBlog2"));
const WebDesignBlog3 = lazy(() => import("../../../components/main_component/aticles/webdesign_article/WebDesignBlog3"));
const WebDesignBlog4 = lazy(() => import("../../../components/main_component/aticles/webdesign_article/WebDesignBlog4"));
const WebDesignBlog5 = lazy(() => import("../../../components/main_component/aticles/webdesign_article/WebDesignBlog5"));
const WebDesignBlog6 = lazy(() => import("../../../components/main_component/aticles/webdesign_article/WebDesignBlog6"));
const WebDesignBlog7 = lazy(() => import("../../../components/main_component/aticles/webdesign_article/WebDesignBlog7"));

// Documentation Blogs
const DocumentationBlog = lazy(() => import("../../../components/main_component/aticles/documentation/DocumentationBlog"));
const DocumentationBlog2 = lazy(() => import("../../../components/main_component/aticles/documentation/DocumentationBlog2"));
const DocumentationBlog3 = lazy(() => import("../../../components/main_component/aticles/documentation/DocumentationBlog3"));
const DocumentationBlog4 = lazy(() => import("../../../components/main_component/aticles/documentation/DocumentationBlog4"));

// DBMS Blogs
const DBMSBlog = lazy(() => import("../../../components/main_component/aticles/dbms_article/DBMSBlog"));
const DBMSBlog2 = lazy(() => import("../../../components/main_component/aticles/dbms_article/DBMSBlog2"));
const DBMSBlog3 = lazy(() => import("../../../components/main_component/aticles/dbms_article/DBMSBlog3"));

// Interview Routinig
const IndexInterviewQuestions = lazy(() => import("../../../components/main_component/posts/InterviewQuestions/IndexInterviewQuestions"));

// Index MCQ
const IndexMcqQuestions = lazy(() => import("../../../components/main_component/posts/MCQsQuestions/IndexMcqQuestions"));
const TechMCQPage = lazy(() => import("../../../components/main_component/posts/MCQsQuestions/TechMCQPage/TechMCQPage"));
const TechMCQList = lazy(() => import("../../../components/main_component/posts/MCQsQuestions/TechMCQPage/TechMCQList"));
// Technogies

// Index Programming Questions

const ProgrammingQuestions = lazy(() => import("../../../components/main_component/posts/programming_questions/ProgrammingQuestions"));
const DatastructurePgramQuestions = lazy(() => import("../../../components/main_component/posts/programming_questions/DatastructurePgramQuestions"));
const IndexProgrammingQuestions = lazy(() => import("../../../components/main_component/posts/programming_questions/IndexProgrammingQuestions"));
const JavaPgramQuestions = lazy(() => import("../../../components/main_component/posts/programming_questions/JavaPgramQuestions"));
const JavascriptPgramQuestions = lazy(() => import("../../../components/main_component/posts/programming_questions/JavascriptPgramQuestions"));
const PythonPgramQuestions = lazy(() => import("../../../components/main_component/posts/programming_questions/PythonPgramQuestions"));

// Index Evens
const IndexEvent = lazy(() => import("../../../components/main_component/events/IndexEvent"));
// index CodeChallange
const CodeChallangeWeek1 = lazy(() => import("../../../components/main_component/code_challange/CodeChallangeWeek1"));
const CodeChallangeWeek2 = lazy(() => import("../../../components/main_component/code_challange/CodeChallangeWeek2"));
const IndexCodeChallange = lazy(() => import("../../../components/main_component/code_challange/IndexCodeChallange"));
const EventGallary = lazy(() => import("../../../components/main_component/events/EventGallary"));

// Practice Question
const CPracticeQuestionsAdvance = lazy(() => import("../../../components/main_component/posts/practice_questions/c_practice_questions/CPracticeQuestionsAdvance"));
const CPracticeQuestionsBeginner = lazy(() => import("../../../components/main_component/posts/practice_questions/c_practice_questions/CPracticeQuestionsBeginner"));
const CPracticeQuestionsIntermediate = lazy(() => import("../../../components/main_component/posts/practice_questions/c_practice_questions/CPracticeQuestionsIntermediate"));
const IndexCPracticeQuestions = lazy(() => import("../../../components/main_component/posts/practice_questions/c_practice_questions/IndexCPracticeQuestions"));
const IndexPracticeQuestions = lazy(() => import("../../../components/main_component/posts/practice_questions/IndexPracticeQuestions"));

const IndexJavaPracticeQuestions = lazy(() => import("../../../components/main_component/posts/practice_questions/java_practice_questions/IndexJavaPracticeQuestions"));
const JavaPracticeQuestionsAdvance = lazy(() => import("../../../components/main_component/posts/practice_questions/java_practice_questions/JavaPracticeQuestionsAdvance"));
const JavaPracticeQuestionsBeginner = lazy(() => import("../../../components/main_component/posts/practice_questions/java_practice_questions/JavaPracticeQuestionsBeginner"));
const JavaPracticeQuestionsIntermediate = lazy(() => import("../../../components/main_component/posts/practice_questions/java_practice_questions/JavaPracticeQuestionsIntermediate"));

const IndexPythonPracticeQuestions = lazy(() => import("../../../components/main_component/posts/practice_questions/python_practice_questions/IndexPythonPracticeQuestions"));
const PythonPracticeQuestionsAdvance = lazy(() => import("../../../components/main_component/posts/practice_questions/python_practice_questions/PythonPracticeQuestionsAdvance"));
const PythonPracticeQuestionsBeginner = lazy(() => import("../../../components/main_component/posts/practice_questions/python_practice_questions/PythonPracticeQuestionsBeginner"));
const PythonPracticeQuestionsIntermediate = lazy(() => import("../../../components/main_component/posts/practice_questions/python_practice_questions/PythonPracticeQuestionsIntermediate"));

const DSPracticeQuestionsAdvance = lazy(() => import("../../../components/main_component/posts/practice_questions/ds_practice_questions/DSPracticeQuestionsAdvance"));
const DSPracticeQuestionsBeginner = lazy(() => import("../../../components/main_component/posts/practice_questions/ds_practice_questions/DSPracticeQuestionsBeginner"));
const DSPracticeQuestionsIntermediate = lazy(() => import("../../../components/main_component/posts/practice_questions/ds_practice_questions/DSPracticeQuestionsIntermediate"));
const IndexDSPracticeQuestions = lazy(() => import("../../../components/main_component/posts/practice_questions/ds_practice_questions/IndexDSPracticeQuestions"));

// Learning Platforms
const CertificationPlatforms = lazy(() => import("../../../components/main_component/aticles/learning_platforms/CertificationPlatforms"));
const ComputerSciencePlatforms = lazy(() => import("../../../components/main_component/aticles/learning_platforms/ComputerSciencePlatforms"));
const DataSciencePlatforms = lazy(() => import("../../../components/main_component/aticles/learning_platforms/DataSciencePlatforms"));
const IndexLearningPlatforms = lazy(() => import("../../../components/main_component/aticles/learning_platforms/IndexLearningPlatforms"));
const ProgrammingLearningPlatforms = lazy(() => import("../../../components/main_component/aticles/learning_platforms/ProgrammingLearningPlatforms"));
const ProgrammingPracticePlatforms = lazy(() => import("../../../components/main_component/aticles/learning_platforms/ProgrammingPracticePlatforms"));
const WebDevelopmentPlatforms = lazy(() => import("../../../components/main_component/aticles/learning_platforms/WebDevelopmentPlatforms"));

// TrainingCertification
const CppTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/CppTrainingCertification"));
const CTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/CTrainingCertification"));
const IndexTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/IndexTrainingCertification"));
const PythonTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/PythonTrainingCertification"));

const AndroidTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/AndroidTrainingCertification"));
const AngularTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/AngularTrainingCertification"));
const ComputerScienceTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/ComputerScienceTrainingCertification"));
const DataScienceTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/DataScienceTrainingCertification"));
const DataStructureTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/DataStructureTrainingCertification"));
const DBMSTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/DBMSTrainingCertification"));
const GithubTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/GithubTrainingCertification"));
const HTMLTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/HTMLTrainingCertification"));
const JavaTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/JavaTrainingCertification"));
const JSTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/JSTrainingCertification"));
const MachineLearningTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/MachineLearningTrainingCertification"));
const NodeJsTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/NodeJsTrainingCertification"));
const OOPsTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/OOPsTrainingCertification"));
const PHPTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/PHPTrainingCertification"));
const ReactJSTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/ReactTrainingCertification"));
const SQLTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/SQLTrainingCertification"));
const SwiftTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/SwiftTrainingCertification"));
const WebdevelopmentTrainingCertification = lazy(() => import("../../../components/main_component/training_and_certification/WebdevelopmentTrainingCertification"));

// Video
const IndexVideo = lazy(() => import("../../../components/main_component/video/IndexVideo"));

// Quiz Board and USer.........
const ContributorHome = lazy(() => import("../../../components/quiz_board/component/contributor/contributor_home"));
const CreateQuizOverview = lazy(() => import("../../../components/quiz_board/component/contributor/create_quiz_test/overview"));
const CreateQuestion = lazy(() => import("../../../components/quiz_board/component/contributor/create_quiz_test/questions"));
const CreateQuizSettings = lazy(() => import("../../../components/quiz_board/component/contributor/create_quiz_test/settings"));
const QuizBoardHome = lazy(() => import("../../../components/quiz_board/component/QuizBoardHome"));
const Confirmation = lazy(() => import("../../../components/user/component/Confirmation"));
const ForgotPassword = lazy(() => import("../../../components/user/component/forgot_password"));
const Login = lazy(() => import("../../../components/user/component/login"));
const NotFound = lazy(() => import("../../../components/user/component/NotFound"));
const ResetPassword = lazy(() => import("../../../components/user/component/reset_password"));
const Signup = lazy(() => import("../../../components/user/component/signup"));
const SocialMediaLinks = lazy(() => import("../../../components/user/component/social_media/SocialMediaLinks"));
const SpeakerRegistration = lazy(() => import("../../../components/user/component/speaker_registration"));
// Contributor --- Tutorial
const AddTutorial = lazy(() => import("../../../components/main_component/tutorials/components/AddTutorial"));
const IndexTechnologies = lazy(() => import("../../../components/main_component/tutorials/components/Tutorials/IndexTutorial"));
const TechTutorials = lazy(() => import("../../../components/main_component/tutorials/components/Tutorials/TechTutorials"));
const TutorialPage = lazy(() => import("../../../components/main_component/tutorials/components/Tutorials/TutorialPage"));
// Profile
const EditProfile = lazy(() => import("../../../components/user/component/profile/edit_profile"));
const MyLibrary = lazy(() => import("../../../components/user/component/profile/my_library"));
const MyProfile = lazy(() => import("../../../components/user/component/profile/my_profile"));
// --------------------------------------------------------------------

const UsersList = lazy(() => import("../../../components/user/component/admin/UsersList"));

// Contributor ------
const ContributorLanding = lazy(() => import("../../../components/contributor"));

// Blogs Text Editor  --------------
const TextEditor = lazy(() => import("../../../components/main_component/aticles/BlogsEditor/TextEditor"));

// New Event
const CreateEventPage = lazy(() => import("../../../components/main_component/events/components/CreateEvent/CreateEventPage"));
const EventDashboard = lazy(() => import("../../../components/main_component/events/components/EventDashboard/EventDashboard"));
const EventDashboardPage = lazy(() => import("../../../components/main_component/events/components/EventDashboard/EventDashboardPage"));
const RegisterList = lazy(() => import("../../../components/main_component/events/components/EventDashboard/RegisterList"));
const EventPage = lazy(() => import("../../../components/main_component/events/components/EventPage/EventPage"));
const GettingStartedWebDev = lazy(() => import("../../../components/main_component/events/components/EventPage/GettingStartedWebDev"));
const EventsList = lazy(() => import("../../../components/main_component/events/components/EventsList"));
const EventsLandingPage = lazy(() => import("../../../components/main_component/events/components/EventsLandingPage"));
const MyRegEvents = lazy(() => import("../../../components/main_component/events/components/EventsList/MyRegEvents"));

// 30DaysCode
const DaysCodeTimeLine = lazy(() => import("../../../components/main_component/DaysCode/components/DaysCodeDashboard/DaysCodeTimeLine"));
const AddQuizChallenge = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/Challenge/AddQuizChallenge"));
const QuizChallengesList = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/Challenge/QuizChallengesList"));
const DaysCodeBatches = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/DaysCodeBatch/DaysCodeBatches"));
const DaysCodeBatchPage = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/DaysCodeBatch/DaysCodeBatchPage"));
const FeedBacks = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/FeedBacks"));
const AddLesson = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/Lesson/AddLesson"));
const LessonsList = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/Lesson/LessonsList"));
const CreateMentor = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/Mentor/CreateMentor"));
const MentorsList = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/Mentor/MentorsList"));
const Notification = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/Notification"));
const AddProblem = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/Problems/AddProblem"));
const ProblemsList = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/Problems/ProblemsList"));
const SubmissionsList = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/Submission/SubmissionsList"));
const AddUserAttendance = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/UserAttendance/AddUserAttendance"));
const UserAttendanceList = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/UserAttendance/UserAttendanceList"));
const DaysUsersList = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/UsersList"));
const AddInterviewQuestions = lazy(() => import("../../../components/main_component/Placement/components/InterviewQuestions/AddInterviewQuestions"));
const InterviewQuestions = lazy(() => import("../../../components/main_component/Placement/components/InterviewQuestions/InterviewQuestions"));
const SuperAdmin = lazy(() => import("../../../components/superadmin/SuperAdmin"));
// const UserSubmissions = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/Submission/UserSubmissions"));

const ProblemPreview = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/Problems/ProblemPreview"));
const UsersProgress = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/Submission/UsersProgress"));
const PageBreak = lazy(() => import("../../../components/user/component/PageBreak"));

// Club
const Applications = lazy(() => import("../../../components/superadmin/Club/components/Applications"));
const ClupApplicationView = lazy(() => import("../../../components/superadmin/Club/components/ClupApplicationView"));
const ClubApplication = lazy(() => import("../../../components/superadmin/Club/components/StudentClubPage/ClubApplication/ClubApplication"));
const StudentLearningClubLanding = lazy(() => import("../../../components/superadmin/Club/components/StudentClubPage/StudentLearningClubLandingPage"));

// Datacode Academy
const AcademyLandingPage = lazy(() => import("../../../components/main_component/DatacodeAcademy/components/AcademyLandingPage/AcademyLandingPage"));
const WorkshopLandingPage = lazy(() => import("../../../components/main_component/DatacodeAcademy/components/Workshop/WorkshopLandingPage"));
const WorkshopPage = lazy(() => import("../../../components/main_component/DatacodeAcademy/components/Workshop/WorkshopPage/WorkshopPage"));
const CreateCodeBatch = lazy(() => import("../../../components/main_component/DaysCode/components/Settings/DaysCodeBatch/CreateCodeBatch"));
const LessonPreview = lazy(() => import("../../../components/main_component/DaysCode/components/DaysCodePage/ContentSections/LessonSection/LessonPreview"));

// Appointment Book
const UserAppointment = lazy(() => import("../../../components/main_component/AppointmentBook/components/UserAppointment"));
const EventRegistration = lazy(() => import("../../../components/main_component/events/components/EventPage/EventRegistration"));
const EventFeedbackForm = lazy(() => import("../../../components/main_component/events/components/EventPage/EventUserAction/EventFeedbackForm"));
const RoleForm = lazy(() => import("../../../components/superadmin/RoleForm"));
const PrivateRoute = lazy(() => import("./PrivateRoute"));
const InternshipProgram = lazy(() => import("../../../components/main_component/Community/components/Carrer"));
const BlogDashBoard = lazy(() => import("../../../components/main_component/Blog/BlogDashBoard"));
const BlogPreview = lazy(() => import("../../../components/main_component/Blog/BlogPreview"));
const AiSummit = lazy(() => import("../../../components/main_component/events/components/EventPage/AiSummit/AiSummit"));
const TechnologyQuestions = lazy(() => import("../../../components/main_component/posts/InterviewQuestions/TechnologyQuestions"));
const Bootcamp = lazy(() => import("../../../components/main_component/Bootcamp"));
const BootcampLayoutPage = lazy(() => import("../../../components/main_component/Bootcamp/BootcampLayoutPage/BootcampLayoutPage"));
const LandingPage = lazy(() =>
  import("../../../components/main_component/landing_page")
);
const ContactUs = lazy(() =>
  import("../header_component/ContactUs")
);
const OurPartners = lazy(() =>
  import("../header_component/OurPartners")
);
const OurStory = lazy(() =>
  import("../header_component/OurStory")
);

// Community
const Community = lazy(() =>
  import("../../../components/main_component/Community/components/Community")
);
// Sagethon
const SagethonPage = lazy(() =>
  import("../../../components/main_component/Sagethon/components/SagethonPage")
);

// FreeCodeClass
const FreeCodeClassPage = lazy(() =>
  import(
    "../../../components/main_component/FreeCodeClass/components/FreeCodeClassPage"
  )
);

// Community
const Wittyhacks = lazy(() =>
  import("../../../components/main_component/Wittyhacks/Wittyhacks")
);

const DaysCodeDashboard = lazy(() =>
  import(
    "../../../components/main_component/DaysCode/components/DaysCodeDashboard"
  )
);
const DaysCode = lazy(() =>
  import("../../../components/main_component/DaysCode/components/DaysCode")
);
const DaysCodePage = lazy(() =>
  import("../../../components/main_component/DaysCode/components/DaysCodePage")
);
const UserBatchDashboard = lazy(() =>
  import(
    "../../../components/main_component/DaysCode/components/Batch/UserBatchesDashboard"
  )
);
const EnrollBatch = lazy(() =>
  import(
    "../../../components/main_component/DaysCode/components/Batch/BatchPage/EnrollBatch"
  )
);
const BatchPage = lazy(() =>
  import(
    "../../../components/main_component/DaysCode/components/Batch/BatchPage"
  )
);

const AppRouters = () => {
  const dispatch = useDispatch();
  const batchMentors = DatacodeConfig.batchMentors || [];
  // const { daysUserDetails, daysUserDetailsLoading } =
  //   useSelector(({ dayscode }) => dayscode) || {};

  // const { currentUser } = useSelector(({ user }) => user);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    var localUser = JSON.parse(localStorage.getItem("userDetails"));
    let token = localStorage.getItem("access_token");
    let batchParticipant = JSON.parse(localStorage.getItem("batchParticipant"));
    let codeBatchDetails = JSON.parse(localStorage.getItem("batchDetails"));
    if (localUser && localUser !== null) {
      dispatch(
        setLocalUser({
          data: localUser,
          token,
          batchParticipant,
          codeBatchDetails,
        })
      );
    }
  }, []);

  const authGuard = (Component) => () => {
    var localUser = JSON.parse(localStorage.getItem("userDetails"));
    return localUser && localUser.userName ? (
      <Component userName={localUser.userName} />
    ) : (
      <Redirect to="/login" />
    );
  };

  const authAdminGuard = (Component) => () => {
    var localUser = JSON.parse(localStorage.getItem("userDetails"));
    return localUser &&
      localUser.userName === process.env.REACT_APP_ADMIN_USERNAME &&
      localUser.email === process.env.REACT_APP_ADMIN_EMAIL ? (
      <Component userName={localUser.userName} />
    ) : (
      <Redirect to="/" />
    );
  };

  const authMentorGuard = (Component) => () => {
    var localUser = JSON.parse(localStorage.getItem("userDetails"));
    return localUser &&
      batchMentors.find(
        (x) => x.email === localUser.email && x.userName === localUser.userName
      ) ? (
      <Component userName={localUser.userName} />
    ) : (
      <Redirect to="/" />
    );
  };

  // const authDaysCodeGuard = (Component1, Component2) => () => {
  //   var localUser = JSON.parse(localStorage.getItem("userDetails"));
  //   return localUser && localUser.dayscodeUser ? (
  //     <Component2 />
  //   ) : (
  //     <Component1 />
  //   );
  // };

  return (
    <>
      <Suspense fallback={<CustomLoader />}>
        <Switch>
          {/* Navigarion Routing */}

          {/* <Route path='/home' component={HomeComponent} /> */}
          <Route path="/our_story" component={OurStory} />
          <Route path="/contact_us" component={ContactUs} />
          <Route path="/our_partners" component={OurPartners} />
          {/* End ______________ */}
          {/* Starting Articles */}
          <Route path="/index_articles" component={IndexArticles} />
          <Route path="/prog_lan_blog" component={ProgrammingLanguagesBlog} />
          <Route path="/prog_lan_blog2" component={ProgrammingBlog2} />
          <Route path="/prog_lan_blog3" component={ProgrammingBlog3} />
          <Route path="/prog_lan_blog4" component={ProgrammingBlog4} />
          <Route path="/prog_lan_blog5" component={ProgrammingBlog5} />
          <Route path="/prog_lan_blog6" component={ProgrammingBlog6} />
          <Route path="/prog_lan_blog7" component={ProgrammingBlog7} />
          <Route path="/prog_lan_blog8" component={ProgrammingBlog8} />
          <Route path="/prog_lan_blog9" component={ProgrammingBlog9} />
          {/* Blogs */}
          <Route path="/blogs" component={BlogDashBoard} />
          <Route path="/blog/preview/:id" component={BlogPreview} />
          <Route path="/blog/:slug" component={BlogPreview} />

          {/* Web Blog */}
          <Route path="/webdesign_blog" component={WebDesignBlog} />
          <Route path="/webdesign_blog2" component={WebDesignBlog2} />
          <Route path="/webdesign_blog3" component={WebDesignBlog3} />
          <Route path="/webdesign_blog4" component={WebDesignBlog4} />
          <Route path="/webdesign_blog5" component={WebDesignBlog5} />
          <Route path="/webdesign_blog6" component={WebDesignBlog6} />
          <Route path="/webdesign_blog7" component={WebDesignBlog7} />
          {/*Machine BLogs  */}
          <Route
            path="/machine_learning_blog"
            component={MachineLearningBlog}
          />
          {/* DBMS Blogs */}
          <Route path="/dbms_blog" component={DBMSBlog} />
          <Route path="/dbms_blog2" component={DBMSBlog2} />
          <Route path="/dbms_blog3" component={DBMSBlog3} />
          {/* Documentation Blog */}
          <Route path="/documentation_blog" component={DocumentationBlog} />
          <Route path="/documentation_blog2" component={DocumentationBlog2} />
          <Route path="/documentation_blog3" component={DocumentationBlog3} />
          <Route path="/documentation_blog4" component={DocumentationBlog4} />
          {/* Ending Article */}

          {/* Starting Index MCQs */}
          <Route exact path="/mcqs" component={IndexMcqQuestions} />
          <Route exact path="/mcqs/:technology" component={TechMCQList} />
          <Route exact path="/mcqs/:technology/:set" component={TechMCQPage} />

          {/* Starting Interview Routing */}
          <Route
            exact
            path="/interview-questions"
            component={IndexInterviewQuestions}
          />
          <Route
            path="/interview-questions/:tech"
            component={TechnologyQuestions}
          />
          {/* Einding Interview Routing */}
          {/* Starting Technologies */}
          <Route exact path="/tutorials" component={IndexTechnologies} />
          {/* Ending Technologies */}
          {/* Starting TrainingCertification */}
          <Route
            exact
            path="/index_training_certification"
            component={IndexTrainingCertification}
          />
          <Route
            exact
            path="/datascience_training_certification"
            component={DataScienceTrainingCertification}
          />
          <Route
            exact
            path="/computerscience_training_certification"
            component={ComputerScienceTrainingCertification}
          />
          <Route
            exact
            path="/machinelearning_training_certification"
            component={MachineLearningTrainingCertification}
          />
          <Route
            exact
            path="/webdevelopment_training_certification"
            component={WebdevelopmentTrainingCertification}
          />
          <Route
            exact
            path="/swift_training_certification"
            component={SwiftTrainingCertification}
          />
          <Route
            exact
            path="/python_training_certification"
            component={PythonTrainingCertification}
          />
          <Route
            exact
            path="/c_training_certification"
            component={CTrainingCertification}
          />
          <Route
            exact
            path="/cpp_training_certification"
            component={CppTrainingCertification}
          />
          <Route
            exact
            path="/java_training_certification"
            component={JavaTrainingCertification}
          />
          <Route
            exact
            path="/js_training_certification"
            component={JSTrainingCertification}
          />
          <Route
            exact
            path="/datastructure_training_certification"
            component={DataStructureTrainingCertification}
          />
          <Route
            exact
            path="/html_training_certification"
            component={HTMLTrainingCertification}
          />
          <Route
            exact
            path="/dbms_training_certification"
            component={DBMSTrainingCertification}
          />
          <Route
            exact
            path="/sql_training_certification"
            component={SQLTrainingCertification}
          />
          <Route
            exact
            path="/oops_training_certification"
            component={OOPsTrainingCertification}
          />
          <Route
            exact
            path="/angular_training_certification"
            component={AngularTrainingCertification}
          />
          <Route
            exact
            path="/react_training_certification"
            component={ReactJSTrainingCertification}
          />
          <Route
            exact
            path="/android_training_certification"
            component={AndroidTrainingCertification}
          />
          <Route
            exact
            path="/nodejs_training_certification"
            component={NodeJsTrainingCertification}
          />
          <Route
            exact
            path="/php_training_certification"
            component={PHPTrainingCertification}
          />
          <Route
            exact
            path="/github_training_certification"
            component={GithubTrainingCertification}
          />
          {/* Ending TrainingCertification */}
          {/* Starting Programming Questions */}
          <Route
            exact
            path="/progamming"
            component={IndexProgrammingQuestions}
          />
          <Route
            exact
            path="/progamming/:tech"
            component={ProgrammingQuestions}
          />
          <Route
            exact
            path="/python_programming_questions"
            component={PythonPgramQuestions}
          />
          <Route
            exact
            path="/java_programming_questions"
            component={JavaPgramQuestions}
          />
          <Route
            exact
            path="/javascript_programming_questions"
            component={JavascriptPgramQuestions}
          />
          <Route
            exact
            path="/datastructure_programming_questions"
            component={DatastructurePgramQuestions}
          />
          {/* Ending Programming Questions  */}
          {/* Starting Event PAge */}
          <Route exact path="/index_events" component={IndexEvent} />
          <Route exact path="/events_gallary" component={EventGallary} />
          <Route
            exact
            path="/event_register"
            component={GettingStartedWebDev}
          />
          <Route
            exact
            path="/event_register_list"
            render={authAdminGuard(RegisterList)}
          />
          <Route exact path="/events" component={EventsLandingPage} />
          <Route exact path="/events-collaborate" component={EventsCollaborateLandingPage} />
          <Route exact path="/events/list" component={EventsList} />
          <Route
            exact
            path="/create_event"
            render={authGuard(CreateEventPage)}
          />
          <Route
            exact
            path="/event/dashboard"
            render={authAdminGuard(EventDashboardPage)}
          />
          <Route
            exact
            path="/event/dashboard/:id"
            render={authAdminGuard(EventDashboard)}
          />
          <Route exact path="/event/:id" component={EventPage} />
          {/* type === register || feedback */}
          <Route
            exact
            path="/event/:id/register"
            component={EventRegistration}
          />
          <Route
            exact
            path="/event/:id/feedback"
            component={EventFeedbackForm}
          />
          <Route exact path="/events/me" render={authGuard(MyRegEvents)} />
          {/* Ending Event PAge */}

          {/* Starting AiSummit Page */}
          <Route exact path="/aisummit" component={AiSummit} />
          <Route exact path="/aisummit/rsvp" component={AiSummit} />
          {/* Starting COde Challange PAge */}
          <Route
            exact
            path="/index_code_challange"
            component={IndexCodeChallange}
          />
          <Route
            exact
            path="/code_challange_week_1"
            component={CodeChallangeWeek1}
          />
          <Route
            exact
            path="/code_challange_week_2"
            component={CodeChallangeWeek2}
          />
          {/* Ending COde Challange PAge */}
          {/* Starting Practice Questions */}
          <Route
            exact
            path="/index_practice_questions"
            component={IndexPracticeQuestions}
          />
          <Route
            exact
            path="/index_c_practice_questions"
            component={IndexCPracticeQuestions}
          />
          <Route
            exact
            path="/c_practice_questions_beginner"
            component={CPracticeQuestionsBeginner}
          />
          <Route
            exact
            path="/c_practice_questions_intermediate"
            component={CPracticeQuestionsIntermediate}
          />
          <Route
            exact
            path="/c_practice_questions_advance"
            component={CPracticeQuestionsAdvance}
          />
          <Route
            exact
            path="/index_java_practice_questions"
            component={IndexJavaPracticeQuestions}
          />
          <Route
            exact
            path="/java_practice_questions_beginner"
            component={JavaPracticeQuestionsBeginner}
          />
          <Route
            exact
            path="/java_practice_questions_intermediate"
            component={JavaPracticeQuestionsIntermediate}
          />
          <Route
            exact
            path="/java_practice_questions_advance"
            component={JavaPracticeQuestionsAdvance}
          />
          <Route
            exact
            path="/index_python_practice_questions"
            component={IndexPythonPracticeQuestions}
          />
          <Route
            exact
            path="/python_practice_questions_beginner"
            component={PythonPracticeQuestionsBeginner}
          />
          <Route
            exact
            path="/python_practice_questions_intermediate"
            component={PythonPracticeQuestionsIntermediate}
          />
          <Route
            exact
            path="/python_practice_questions_advance"
            component={PythonPracticeQuestionsAdvance}
          />
          <Route
            exact
            path="/index_ds_practice_questions"
            component={IndexDSPracticeQuestions}
          />
          <Route
            exact
            path="/ds_practice_questions_beginner"
            component={DSPracticeQuestionsBeginner}
          />
          <Route
            exact
            path="/ds_practice_questions_intermediate"
            component={DSPracticeQuestionsIntermediate}
          />
          <Route
            exact
            path="/ds_practice_questions_advance"
            component={DSPracticeQuestionsAdvance}
          />
          {/* Ending Code Challange */}
          {/* Strting Learning Platform  */}
          <Route
            exact
            path="/index_learning_platforms"
            component={IndexLearningPlatforms}
          />
          <Route
            exact
            path="/certification_platforms"
            component={CertificationPlatforms}
          />
          <Route
            exact
            path="/webdevelopment_platforms"
            component={WebDevelopmentPlatforms}
          />
          <Route
            exact
            path="/programming_practice_platforms"
            component={ProgrammingPracticePlatforms}
          />
          <Route
            exact
            path="/programming_learning_platforms"
            component={ProgrammingLearningPlatforms}
          />
          <Route
            exact
            path="/datascience_platforms"
            component={DataSciencePlatforms}
          />
          <Route
            exact
            path="/computerscience_platforms"
            component={ComputerSciencePlatforms}
          />
          {/* Ending Learning paltform */}
          {/* Starting video  */}
          <Route exact path="/index_video" component={IndexVideo} />
          {/* Ending Video */}

          {/*Quiz Board and User. . . . .  */}
          <Route exact path="/quiz_board_home" component={QuizBoardHome} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/signup" component={Signup} />
          <Route exact path="/confirmation/:type" component={Confirmation} />
          <Route exact path="/forgot_password" component={ForgotPassword} />
          <Route
            exact
            path="/reset_password/:resetCode"
            component={ResetPassword}
          />
          <Route path="/contributor_home" render={authGuard(ContributorHome)} />
          <Route
            path="/create_quiz_test_overview/:quizId"
            render={authGuard(CreateQuizOverview)}
          />
          <Route
            exact
            path="/create_quiz_test_question"
            component={CreateQuestion}
          />
          <Route
            exact
            path="/create_quiz_test_settings"
            render={authGuard(CreateQuizSettings)}
          />
          {/* -------------------- */}
          <Route exact path="/social_media" component={SocialMediaLinks} />
          <Route exact path="/apply-speaker" component={SpeakerRegistration} />
          {/* ------------------------ */}
          {/*Admin . . . Contributor Tutorial  */}
          {/* <Route path="/add_tutorial" render={authGuard(AddTutorial)} /> */}
          <Route path="/add_tutorial" render={authGuard(AddTutorial)} />
          {/* Tutorials Tech Pages */}
          <Route path="/tutorials/:technology" component={TechTutorials} />
          <Route path="/tutorial/:id" component={TutorialPage} />
          {/* Profile */}
          {/* <Route path="/my_profile/:email" render={authGuard(MyProfile)} /> */}
          <Route path="/my_profile/:userName" component={MyProfile} />
          <Route path="/profile/:userName" component={MyProfile} />
          <Route exact path="/edit_profile" render={authGuard(EditProfile)} />
          <Route exact path="/my_library" render={authGuard(MyLibrary)} />
          <Route exact path="/admin/users" render={authAdminGuard(UsersList)} />
          {/* Contributor Landing */}
          <Route exact path="/contributor" component={ContributorLanding} />
          {/* -------BLog Editor---- */}
          <Route path="/editor" component={TextEditor} />
          {/* ____________________________________________ */}
          {/* Days Code */}
          {/* <Route
            path="/dayscode/batches"
            component={UserBatchDashboard}
          /> */}
          <PrivateRoute
            path="/dayscode/batch/:batch/enroll"
            component={EnrollBatch}
          />
          {/* <Route path="/days_code_problems" render={authDaysCodeGuard(DaysCode, DaysCodePage)} /> */}
          {/*  This changes is only after batch ended */}
          <PrivateRoute
            path="/dayscode/batch/:batch/content"
            checkBatchUser={true}
            checkBatchStatus={true}
            component={DaysCodePage}
            alternateComponent={BatchPage}
          />
          <PrivateRoute
            path="/dayscode/batch/:batch/dashboard"
            checkBatchUser={true}
            checkBatchStatus={true}
            component={DaysCodeDashboard}
            alternateComponent={BatchPage}
          />
          <PrivateRoute path="/dayscode/batch/:batch" component={BatchPage} />
          <PrivateRoute
            path="/dayscode"
            component={DaysCode}
            checkDaysCodeUser={true}
            alternateComponent={UserBatchDashboard}
          />
          <Route path="/role" component={RoleForm} />
          <Route
            path="/admin/dayscode/problem/preview/:id"
            render={authMentorGuard(ProblemPreview)}
          />
          <Route
            path="/admin/dayscode/problem/:id"
            render={authMentorGuard(AddProblem)}
          />
          <Route
            path="/admin/dayscode/problems"
            render={authMentorGuard(ProblemsList)}
          />
          <Route
            path="/admin/dayscode/submissions"
            render={authMentorGuard(SubmissionsList)}
          />
          <Route
            path="/admin/dayscode/users/:batchId"
            render={authAdminGuard(DaysUsersList)}
          />
          <Route
            path="/admin/dayscode/notification"
            render={authMentorGuard(Notification)}
          />
          <Route
            path="/admin/dayscode/lesson/:id"
            render={authMentorGuard(AddLesson)}
          />
          <Route
            path="/admin/dayscode/lessons"
            render={authMentorGuard(LessonsList)}
          />
          <Route
            path="/admin/dayscode/quiz_challenge/:id"
            render={authAdminGuard(AddQuizChallenge)}
          />
          <Route
            path="/admin/dayscode/quiz_challenges"
            render={authAdminGuard(QuizChallengesList)}
          />
          <Route
            path="/admin/dayscode/user_attendance_list"
            render={authMentorGuard(UserAttendanceList)}
          />
          <Route
            path="/admin/dayscode/session_attendance"
            render={authMentorGuard(AddUserAttendance)}
          />
          <Route
            path="/admin/dayscode/feedbacks"
            render={authAdminGuard(FeedBacks)}
          />
          <Route
            path="/admin/dayscode/batch_users"
            render={authMentorGuard(UsersProgress)}
          />
          <Route
            path="/admin/dayscode/batch/:id"
            render={authAdminGuard(CreateCodeBatch)}
          />
          <Route
            path="/admin/dayscode/batch_dashboard/:id"
            render={authAdminGuard(DaysCodeBatchPage)}
          />
          <Route
            path="/admin/dayscode/batches"
            render={authAdminGuard(DaysCodeBatches)}
          />
          <Route
            path="/admin/dayscode/mentor/:id"
            render={authAdminGuard(CreateMentor)}
          />
          <Route
            path="/admin/dayscode/mentors"
            render={authAdminGuard(MentorsList)}
          />
          <Route path="/days_timeline" component={DaysCodeTimeLine} />
          {/* FreeCode Class */}

          <Route path="/free-class" component={FreeCodeClassPage} />
          //Revision
          <Route path="/revision" component={RevisionLandingPage} />
          {/* Bootcamp */}

          <Route path="/bootcamp" component={Bootcamp} />
          <Route path="/datacode-bootcamp" component={BootcampLayoutPage} />

          {/* Appointment Book */}
          <Route path="/appointment/:event" component={UserAppointment} />
          {/* Datacode Community */}
          <Route path="/community" component={Community} />
          {/* Datacode Community */}
          <Route path="/sagethon" component={SagethonPage} />
          {/* Interview / Placement */}

          {/* Internship_Program/Carrer */}
          <Route path="/internship" component={InternshipProgram}></Route>
          <Route
            path="/add_interview_questions"
            component={AddInterviewQuestions}
          />
          <Route path="/interview_questions" component={InterviewQuestions} />
          {/* Club Routes */}
          <Route path="/club/application" component={ClubApplication} />
          <Route path="/club" component={StudentLearningClubLanding} />
          <Route
            path="/admin/club/applications"
            render={authAdminGuard(Applications)}
          />
          <Route
            path="/admin/club/application/:id"
            render={authAdminGuard(ClupApplicationView)}
          />
          {/* Datacode Academy */}
          <Route path="/academy/workshop/:id" component={WorkshopPage} />
          <Route path="/academy/workshop" component={WorkshopLandingPage} />
          <Route path="/academy" component={AcademyLandingPage} />
          {/* Super Admin  Routes*/}
          <Route path="/admin" render={authAdminGuard(SuperAdmin)} />
          {/* wittyhacks */}
          <Route exact path="/wittyhacks" component={Wittyhacks} />
          <Route path="/error" component={PageBreak} />
          <Route exact path="/" component={LandingPage} />
          <Route path="*" component={NotFound} />
        </Switch>
      </Suspense>
    </>
  );
};

export default AppRouters;
